import { Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import { StorageService } from "../../services/storage.service";
import Swal from "sweetalert2";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { IsPointV2, AppLogo2, ClgLogo } from "src/app/app.config";
import { CommonService } from "src/app/services/common.service";
@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.css"],
})
export class ResetPasswordComponent implements OnInit {
  submitted = false;
  appLogo = AppLogo2;
  clgLogo = ClgLogo;
  private ls = new SecureLS({ encodingType: "aes" });
  verifyotp: any;
  otp: any;
  forget: any;
  but = false;
  verifyotp1: Response;
  resend: Response;
  getroles: Object;
  RoleChange: any;
  selectedRole: any;
  multiRoleLogin: Response;
  showError: any = false;
  constructor(
    private storageService: StorageService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    public router: Router,
    public globalService: GlobalService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private commonService: CommonService
  ) {}
  ngOnInit(): void {
    if (this.storageService.clearIntval) {
      clearInterval(this.storageService.clearIntval);
    }
    this.forget = this.route.snapshot.paramMap.get("id");

    if (this.forget) {
      this.but = true;
    }
  }
  async forgot() {
    this.spinner.show();
    let inputData = {
      user_id: this.ls.get("user_id"),
      role_id: this.storageService.getRole(),
      otp: this.otp,
    };
    this.verifyotp1 = await this.globalService.create(
      "user/vfy-forgot-password-otp",
      inputData
    );

    if (this.verifyotp1["status"] === 200) {
      let compData = this.verifyotp1["content"];

      this.ls.set("key", compData.key);
      this.ls.set("role", compData.role_id);
      this.ls.set("user_id", compData.id);
      this.ls.set("password", compData.is_password_updated);
      this.spinner.hide();
      this.router.navigate(["/update-password"]);
    } else {
      this.spinner.hide();
    }
  }
  async validateOtp(contentlist) {
    this.spinner.show();
    if (this.otp) {
      let inputData = {
        user_id: this.ls.get("user_id"),
        role_id: this.ls.get("role"),
        otp: this.otp,
      };
      this.verifyotp = await this.globalService.create(
        "user/verify-otp",
        inputData,
        IsPointV2
      );

      if (this.verifyotp["status"] === 200) {
        let compData = this.verifyotp["content"];
        this.ls.set("is_multiple_role", compData.is_multiple_role);
        if (compData?.user_info?.userByRole?.length == 1) {
          if (!this.ls.get("role")) {
            this.ls.set(
              "role",
              compData.user_info.userByRole[0].userRole.role_id
            );
          }
        } else {
          if (!this.ls.get("role")) {
            this.ls.set("role", compData?.user_info?.role_id);
          }
        }
        if (
          compData.user_info.userByRole.length === 1 ||
          compData.user_info.userByRole.length === 0
        ) {
          this.commonService.setLSDataFromResponse(compData);
        } else {
          this.selectedRole = null;
          this.modalService.open(contentlist, { centered: true, size: "md" });
          this.RoleChange = compData.user_info.userByRole;
        }
      }
    } else {
      Swal.fire("Error", "Please Enter Otp", "error");
    }
    this.spinner.hide();
  }

  async changeRoles(selectedRole) {
    if (selectedRole) {
      this.commonService.changeRoleService(selectedRole);
    } else {
      this.showError = true;
    }
  }

  async resendOtp() {
    this.spinner.show();
    let inputData = {
      user_id: this.ls.get("user_id"),
      role_id: this.storageService.getRole(),
    };

    this.resend = await this.globalService.create("user/resend-OTP", inputData);
    if (this.resend) {
      let otpInput: HTMLCollectionOf<Element> =
        document.getElementsByTagName("ng-otp-input");
      let elem = <HTMLElement>otpInput[0].firstChild;
      for (let i = 0; i < 6; i++) {
        if (elem) {
          (elem.children[i] as HTMLInputElement).value = "";
        }
      }
      this.spinner.hide();
    }
  }

  onOtpChange(e) {
    if (!/\D/.test(e)) {
      if (e.length == 6) {
        this.otp = e;
      }
    } else {
      Swal.fire("Error", "Please Enter only Numbers", "error");
    }
  }
}
